(() => {
  const campaignName = 'donarturo_warehouse_clearance';
  const linkDefinitions = [
    { selector: '.ed-brand-profile-link', ref: 'landing_brand_story' },
    { selector: '.ed-badge-link', ref: 'landing_sale_badge' },
    { selector: '.ed-button', ref: 'landing_shop_final' }
  ];

  const publishClick = (campaignRef, linkUrl, linkText) => {
    if (!window.Shopify?.analytics?.publish) return;

    window.Shopify.analytics.publish('fluf:donarturo_cta_click', {
      campaign_name: campaignName,
      campaign_ref: campaignRef,
      link_url: linkUrl,
      link_text: linkText
    });
  };

  const labelLink = ({ selector, ref }) => {
    document.querySelectorAll(`.da-editorial-wrapper ${selector}`).forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;

      const destination = new URL(link.href, window.location.origin);
      if (destination.origin !== window.location.origin) return;

      destination.searchParams.set('campaign_ref', ref);
      const labelledHref = `${destination.pathname}${destination.search}${destination.hash}`;
      link.setAttribute('href', labelledHref);
      link.dataset.campaignRef = ref;

      link.addEventListener('click', () => {
        publishClick(ref, labelledHref, link.textContent.trim());
      });
    });
  };

  const labelExplicitLinks = () => {
    document.querySelectorAll('.da-lookbook-gallery a[data-campaign-ref]').forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;

      const campaignRef = link.dataset.campaignRef;
      if (!campaignRef) return;

      const destination = new URL(link.href, window.location.origin);
      if (destination.origin !== window.location.origin) return;

      const labelledHref = `${destination.pathname}${destination.search}${destination.hash}`;
      link.addEventListener('click', () => {
        publishClick(campaignRef, labelledHref, link.textContent.trim());
      });
    });
  };

  const initialise = () => {
    linkDefinitions.forEach(labelLink);
    labelExplicitLinks();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
